import { BidDocuments, TollRoads } from "components/bid/show/partials";
import BidSyncStatusInfo from "components/shared/bidSyncStatusInfo";
import CostAwarePrice from "components/shared/costAwarePrice";
import { distributionBidInProcessModal } from "components/shared/distributionBidInProcessModal";
import ForwardingSource from "components/shared/forwardingSource";
import Loader from "components/shared/loader";
import ShippingOrderSection from "components/shared/shippingOrderSection";
import TypeOptions from "components/shared/typeOptionsShow";
import { counterpartyInsolvencyTooltip, formatExtendedProp } from "helpers/bid";
import { sortedPoints } from "helpers/bidpoint";
import { dateTimeToView, dateToView } from "helpers/date";
import {
    distributionBidPaymentTypesEnum,
    featureModuleTypesEnum,
    invoiceTriggerTypes,
    parcelRelationTypesEnum,
    paymentPeriodTypes,
    sourceTypes,
} from "helpers/enums";
import { HiddenDataWrapper, hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { enumLabel, formatNumber } from "helpers/system";
import compact from "lodash/compact";
import policy from "policies";
import Tooltip from "rc-tooltip";
import React, { Component, Fragment } from "react";
import SignalRConnection from "services/signalRConnection";
import { getDistributionBid } from "sources/books/distributionBids";
import { getDistributionBidItem as getRouteControlDistributionBidPoints } from "sources/books/routeControlPoints";
import { getList as getUserEntityOptions } from "sources/catalogs";
import { getCombinedProperties } from "sources/extendedProperties";
import { getRouteByDistributionBidId } from "sources/map";
import { getItem as getShippingOrder } from "sources/shippingOrders";
import DistributionBidPaymentStatus from "../paymentStatus";
import connect from "./bodyConnect";
import {
    BidActions,
    BidHead,
    BidParcels,
    CargoPoints,
    Contract,
    ContractNumber,
    LegalPerson,
    Timeline,
} from "./partials";

class DistributionBidShow extends Component {
    state = {
        data: {},
        isLoading: true,
        extendedPropertiesConfig: { bid: [], bidPoints: [], cargo: [] },
    };

    constructor(props) {
        super(props);
        const { profile, roles } = props;
        this.bidPolicy = policy("bid", { user: { profile, roles } });
        this.temperatureRegimeEnabled = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.TemperatureRegime,
        );
    }

    componentDidMount() {
        this.getItem(this.props).then(() => {
            const { id } = this.props;
            this.connection = new SignalRConnection({
                url: "/signalr/distributionbids",
                connectionParams: id,
                actions: [{ name: "Update", action: this.receiveUpdate }],
                joinActionName: "Join",
                leaveActionName: "Leave",
            });
        });
        getCombinedProperties({ excludeHidden: true, isRelation: false }).then((extendedPropertiesConfig) =>
            this.setState({ extendedPropertiesConfig }),
        );
        getUserEntityOptions().then((userEntityOptions) => this.setState({ userEntityOptions }));
    }

    componentWillUnmount() {
        this.resetMapBid();
    }

    receiveUpdate = (data) => {
        const { updateModal } = this.props;
        if (data.updateDocuments) {
            updateModal({ documentsUpdatedAt: Date.now() });
        }
    };

    resetMapBid = () => {
        const { mergeMapData } = this.props;
        mergeMapData({
            distributionBidRoute: null,
            currentBid: null,
            bidPoints: null,
            routeControlPoints: null,
        });
    };

    componentDidUpdate(prevProps) {
        if (this.props.mapBid && this.props.match.params.id !== this.props.mapBid) {
            this.resetMapBid();
        }
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.getItem(this.props).then(() => {
                if (this.props.match.params.id !== prevProps.match.params.id) {
                    this.connection && this.connection.disconnect();
                    const { id } = this.props;
                    this.connection = new SignalRConnection({
                        url: "/signalr/distributionbids",
                        connectionParams: id,
                        actions: [{ name: "Update", action: this.receiveUpdate }],
                        joinActionName: "Join",
                        leaveActionName: "Leave",
                    });
                }
            });
        }
    }

    getItem = (nextProps) => {
        const { profile, id, mergeMapData } = nextProps || this.props;
        const nextState = {
            isLoading: true,
            profile,
        };
        mergeMapData({ isLoading: true, currentBid: id });
        this.setState(nextState);
        return Promise.all([getDistributionBid(id), getRouteByDistributionBidId(id)]).then(([data, route]) => {
            const shippingOrderRequest = data.shippingOrder?.id
                ? getShippingOrder(data.shippingOrder.id)
                : Promise.resolve(null);

            return shippingOrderRequest.catch(() => null).then((shippingOrder) => {
                const detailedData = shippingOrder ? { ...data, shippingOrder } : data;

                if (detailedData.inProcessByUser && detailedData.inProcessByUser.id !== this.props.profile.id) {
                    this.props.modal(
                        distributionBidInProcessModal({ userName: detailedData.inProcessByUser.shortName }),
                    );
                }
                this.setState({ isLoading: false, data: detailedData, route, routeIsLoaded: true });
                mergeMapData({
                    distributionBidRoute: route,
                    bidPoints: sortedPoints(detailedData.bidPoints),
                    isLoading: false,
                    compareBidId: id,
                });
                if (profile.availableFeatureModules.includes(featureModuleTypesEnum.RouteControlPoints)) {
                    getRouteControlDistributionBidPoints(id).then((routeControlPoints) =>
                        mergeMapData({ routeControlPoints, compareBidId: id }),
                    );
                }
            });
        });
    };

    back = () => {
        this.props.back();
    };

    renderActions = () => {
        if (!this.state.data) {
            return null;
        }
        const { id, history, mergeParams, modal, organization, roles, profile } = this.props;
        const props = {
            id,
            modal,
            history,
            mergeParams,
            organization,
            roles,
            profile,
            bidPolicy: this.bidPolicy,
            getItem: this.getItem,
            back: this.back,
            setLoading: (isLoading) => this.setState({ isLoading }),
            ...this.state,
        };
        return <BidActions {...props} />;
    };

    renderHead = () => {
        const { id, mergeParams, modal, organization } = this.props;
        const props = { ...this.state, id, back: this.back, mergeParams, refresh: this.getItem, modal, organization };
        return <BidHead {...props} />;
    };

    renderCargoPoints = () => {
        const props = { ...this.state };
        const { enums } = this.props;
        return <CargoPoints {...props} enums={enums} renderExtendedProperties={this.renderExtendedProperties} />;
    };

    renderTollRoads = () => {
        const { tollRoadSegments } = this.state.route || {};

        if (!tollRoadSegments?.length) {
            return null;
        }

        return <TollRoads tollRoads={tollRoadSegments} modal={this.props.modal} route={this.state.route} />;
    };

    renderTimeline = () => {
        return <Timeline {...this.timelineProps} organization={this.props.organization} />;
    };

    get timelineProps() {
        const {
            extendedPropertiesConfig,
            data: { bidPoints },
        } = this.state;
        return {
            points: sortedPoints(bidPoints),
            extendedPropertiesConfig,
            mergeMapViewport: this.props.mergeMapViewport,
            loadUnloadType: this.props.enums.loadUnloadType,
        };
    }

    mainInfoHeader = () => {
        return <div className="show-bid__section-header">Информация о заказе</div>;
    };

    renderComment = () => {
        const { comment } = this.state.data;
        if (!comment) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Комментарий</div>
                <div className="show-bid__main-info--value" data-test-id="comment">
                    {comment}
                </div>
            </>
        );
    };

    renderCancellationComment = () => {
        const { cancelComment } = this.state.data;
        if (!cancelComment) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Причина отмены</div>
                <div className="show-bid__main-info--value" data-test-id="cancel-comment">
                    {cancelComment}
                </div>
            </>
        );
    };

    renderContact = () => {
        const { contactPerson } = this.state.data;
        if (!contactPerson) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Контактное лицо</div>
                <div className="show-bid__main-info--value" data-test-id="contact-person">
                    {compact([contactPerson.name, contactPerson.phoneNumber]).join(", ")}
                </div>
            </>
        );
    };

    renderBid = () => {
        const { bidId } = this.state.data;
        if (!bidId) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Заявка</div>
                <div className="show-bid__main-info--value" data-test-id="bid">
                    <a href={`${paths.bidShow("bid", bidId)}`} target="_blank" rel="noopener noreferrer">
                        {bidId}
                    </a>
                </div>
            </>
        );
    };

    renderTypeOptions = () => {
        const {
            userEntityOptions,
            data: { typeOptions },
        } = this.state;
        if (!typeOptions || typeOptions.length === 0) {
            return null;
        }
        const { enums } = this.props;
        const props = { typeOptions, enums, userEntityOptions, checkBidRelation: true };
        return <TypeOptions {...props} />;
    };

    renderContractNumber = () => <ContractNumber {...this.state.data} roles={this.props.roles} />;

    renderLegalPerson = () => <LegalPerson {...this.state.data} />;

    renderContract = () => <Contract {...this.state.data} roles={this.props.roles} />;

    renderSource = () => {
        const { source } = this.state.data;
        if (!source) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Источник заказа</div>
                <div className="show-bid__main-info--value" data-test-id="source">
                    <ForwardingSource {...source} />
                </div>
            </>
        );
    };

    openDocumentsModal = () => {
        this.props.modal({
            title: "Сформировать документы",
            name: "bidDocuments",
            windowMod: "wide",
            bid: this.state.data,
            profile: this.props.profile,
            roles: this.props.roles,
            bidType: "distributionBid",
        });
    };

    renderPrice = () => {
        const {
            costs,
            ndsTypeId,
            paymentTypeId,
            price,
            priceWithoutCosts,
            paymentPeriodType,
            paymentPeriodInDays,
            invoiceTriggerType,
            hasHiredCar,
            customerPayment,
        } = this.state.data;
        const { enums, roles, organization, profile } = this.props;
        const hasAccountsReceivable = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.AccountsReceivable,
        );
        const hasPriceData = price != null || ndsTypeId || paymentTypeId;
        const hasCostAwarePrice = priceWithoutCosts != null;
        const canCreateDocuments =
            profile.availableFeatureModules.includes(featureModuleTypesEnum.CrStart) &&
            hasHiredCar &&
            !roles.isTruckingOrganizationExtendedViewer;

        if (
            !(
                hasPriceData ||
                hasCostAwarePrice ||
                paymentPeriodType ||
                paymentPeriodInDays != null ||
                invoiceTriggerType ||
                canCreateDocuments
            )
        ) {
            return false;
        }

        return (
            <>
                {(hasPriceData || canCreateDocuments) && (
                    <>
                        <div className="show-bid__main-info--title">{hasPriceData ? "Цена" : "Документы"}</div>
                        <div className="show-bid__main-info--value" data-test-id="price">
                            {hasPriceData &&
                                hiddenUserData(
                                    formatNumber(price, { style: "currency", currency: organization?.currency }),
                                    { type: "price" },
                                    roles.isTruckingOrganizationDispatcher,
                                )}
                            &nbsp;
                            <HiddenDataWrapper>
                                {paymentTypeId && ndsTypeId && (
                                    <span className="text-muted">
                                        (
                                        {`${enumLabel(enums.paymentType, paymentTypeId)}, ${enumLabel(
                                            enums.nDSType,
                                            ndsTypeId,
                                        )}`}
                                        )
                                    </span>
                                )}
                            </HiddenDataWrapper>
                            {canCreateDocuments && (
                                <Tooltip
                                    overlay="Формирование документов (счет, акт, счет-фактура...)"
                                    placement="bottom"
                                    overlayClassName="mw-200"
                                >
                                    <div className="show-bid__link d-inline-block" onClick={this.openDocumentsModal}>
                                        Сформировать документы
                                    </div>
                                </Tooltip>
                            )}
                        </div>
                    </>
                )}
                <CostAwarePrice
                    costs={costs}
                    currency={organization?.currency}
                    hidden={roles.isTruckingOrganizationDispatcher}
                    modal={this.props.modal}
                    price={price}
                    priceLabel="Цена заказа"
                    priceWithoutCosts={priceWithoutCosts}
                />
                {(paymentPeriodType || paymentPeriodInDays != null) && (
                    <>
                        <div className="show-bid__main-info--title">Срок оплаты</div>
                        <div className="show-bid__main-info--value" data-test-id="payment-period">
                            {hiddenUserData(
                                formatNumber(paymentPeriodInDays),
                                {},
                                roles.isTruckingOrganizationDispatcher,
                            )}
                            &nbsp;
                            <HiddenDataWrapper hidden={roles.isTruckingOrganizationDispatcher}>
                                {paymentPeriodType && (
                                    <span className="text-muted">
                                        ({enumLabel(paymentPeriodTypes, paymentPeriodType)})
                                    </span>
                                )}
                            </HiddenDataWrapper>
                        </div>
                    </>
                )}
                {invoiceTriggerType && (
                    <>
                        <div className="show-bid__main-info--title">Основание для выставления счёта</div>
                        <div className="show-bid__main-info--value" data-test-id="invoice-trigger-type">
                            <HiddenDataWrapper hidden={roles.isTruckingOrganizationDispatcher}>
                                {enumLabel(invoiceTriggerTypes, invoiceTriggerType)}
                            </HiddenDataWrapper>
                        </div>
                    </>
                )}
                {!roles.isTruckingOrganizationDispatcher &&
                    (customerPayment || (hasHiredCar && hasAccountsReceivable)) && (
                        <>
                            <div className="show-bid__main-info--title">Статус оплаты заказчика</div>
                            <div className="show-bid__main-info--value">
                                <DistributionBidPaymentStatus
                                    bid={this.state.data}
                                    bidPolicy={this.bidPolicy}
                                    dataTestId="customer-payment-status"
                                    organization={organization}
                                    paymentType={distributionBidPaymentTypesEnum.Customer}
                                    profile={profile}
                                    refresh={this.getItem}
                                    roles={roles}
                                />
                            </div>
                        </>
                    )}
            </>
        );
    };

    renderTrailerType = () => {
        const { trailerTypeId } = this.state.data;
        const { enums } = this.props;

        if (!trailerTypeId) {
            return false;
        }

        return (
            <>
                <div className="show-bid__main-info--title">Тип прицепа</div>
                <div className="show-bid__main-info--value" data-test-id="trailer-type">
                    <span className="text-muted">{enumLabel(enums.trailerType, trailerTypeId)}</span>
                </div>
            </>
        );
    };

    renderCounterparty = () => {
        const { counterparty } = this.state.data;
        if (!counterparty) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Контрагент</div>
                <div className="show-bid__main-info--value" data-test-id="counterparty">
                    {counterparty.name}
                    {counterparty?.insolvencyRegistryEntry &&
                        counterparty?.insolvencyRegistryEntry.insolvencyRank > 0 && (
                            <HiddenDataWrapper>
                                <br />
                                {counterpartyInsolvencyTooltip(counterparty.insolvencyRegistryEntry, this.props.modal)}
                            </HiddenDataWrapper>
                        )}
                </div>
            </>
        );
    };

    renderCreatedAtInfo = () => {
        const { createdAt, createdBy, sourceType } = this.state.data;
        return (
            <>
                <div className="show-bid__main-info--title">Создан</div>
                <div className="show-bid__main-info--value" data-test-id="created-at">
                    {createdBy.shortName}
                    <span className="badge badge-primary ml-1 mr-1">{enumLabel(sourceTypes, sourceType)}</span>
                    <span>{dateTimeToView(createdAt)}</span>
                </div>
            </>
        );
    };

    renderDistance = () => {
        const { distance } = this.state.data;
        if (!distance) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Дистанция</div>
                <div className="show-bid__main-info--value" data-test-id="distance">
                    {formatNumber(distance)}&nbsp;км
                </div>
            </>
        );
    };

    renderOutput = () => {
        const { output } = this.state.data;
        if (!output) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">
                    Выработка ({this.props.organization?.currencyData?.name}/км)
                </div>
                <div className="show-bid__main-info--value" data-test-id="output">
                    <b>{hiddenUserData(formatNumber(output), { type: "pricePerVal" })}</b>
                </div>
            </>
        );
    };

    renderHiredCar = () => {
        const {
            hasHiredCar,
            hiredCarCounterparty,
            hiredCarPrice,
            hiredCarCompletedAt,
            hiredCarPaymentTypeId,
            hiredCarNdsTypeId,
            hiredCarPaymentPeriodType,
            hiredCarPaymentPeriodInDays,
            hiredCarInvoiceTriggerType,
            hiredCar,
            hiredTrailer,
            hiredDriver,
            hiredCarPayment,
        } = this.state.data;
        if (!hasHiredCar) {
            return null;
        }
        const hiredCarInfo = hiredCar
            ? compact([enumLabel(this.props.enums.carBrandType, hiredCar.brandTypeId, ""), hiredCar.number]).join(", ")
            : "";
        const hiredTrailerInfo = hiredTrailer
            ? compact([
                  enumLabel(this.props.enums.trailerType, hiredTrailer.typeId, ""),
                  enumLabel(this.props.enums.trailerBrandType, hiredTrailer.brandTypeId, ""),
                  hiredTrailer.number,
              ]).join(", ")
            : "";
        const hasAccountsReceivable = this.props.profile.availableFeatureModules.includes(
            featureModuleTypesEnum.AccountsReceivable,
        );
        return (
            <>
                {hiredCarCounterparty && (
                    <>
                        <div className="show-bid__main-info--title">Перевозчик</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-counterparty">
                            {hiredCarCounterparty.name}
                        </div>
                    </>
                )}
                {hiredCarPrice != null && (
                    <>
                        <div className="show-bid__main-info--title">Сумма для перевозчика</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-price">
                            {hiddenUserData(
                                formatNumber(hiredCarPrice, {
                                    style: "currency",
                                    currency: this.props.organization?.currency,
                                }),
                                {
                                    type: "price",
                                },
                            )}
                        </div>
                    </>
                )}
                {(hiredCarPaymentTypeId || hiredCarNdsTypeId) && (
                    <>
                        <div className="show-bid__main-info--title">Оплата перевозчику</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-payment">
                            {compact([
                                enumLabel(this.props.enums.paymentType, hiredCarPaymentTypeId, ""),
                                enumLabel(this.props.enums.nDSType, hiredCarNdsTypeId, ""),
                            ]).join(", ")}
                        </div>
                    </>
                )}
                {(hiredCarPaymentPeriodType || hiredCarPaymentPeriodInDays != null) && (
                    <>
                        <div className="show-bid__main-info--title">Срок оплаты перевозчику</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-payment-period">
                            {formatNumber(hiredCarPaymentPeriodInDays)}
                            &nbsp;
                            {hiredCarPaymentPeriodType && (
                                <span className="text-muted">
                                    ({enumLabel(paymentPeriodTypes, hiredCarPaymentPeriodType)})
                                </span>
                            )}
                        </div>
                    </>
                )}
                {hiredCarInvoiceTriggerType && (
                    <>
                        <div className="show-bid__main-info--title">Основание для выставления счёта перевозчику</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-invoice-trigger-type">
                            {enumLabel(invoiceTriggerTypes, hiredCarInvoiceTriggerType)}
                        </div>
                    </>
                )}
                {!this.props.roles.isTruckingOrganizationDispatcher &&
                    (hiredCarPayment || (hasHiredCar && hasAccountsReceivable)) && (
                        <>
                            <div className="show-bid__main-info--title">Статус выплаты перевозчику</div>
                            <div className="show-bid__main-info--value">
                                <DistributionBidPaymentStatus
                                    bid={this.state.data}
                                    bidPolicy={this.bidPolicy}
                                    dataTestId="hired-car-payment-status"
                                    isAccountsPayable
                                    organization={this.props.organization}
                                    paymentType={distributionBidPaymentTypesEnum.HiredCar}
                                    profile={this.props.profile}
                                    refresh={this.getItem}
                                    roles={this.props.roles}
                                />
                            </div>
                        </>
                    )}
                {hiredCarCompletedAt && (
                    <>
                        <div className="show-bid__main-info--title">Дата выполнения</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-completed-at">
                            {dateTimeToView(hiredCarCompletedAt)}
                        </div>
                    </>
                )}
                {hiredCar && (
                    <>
                        <div className="show-bid__main-info--title">Наёмный автомобиль</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-car-number">
                            {hiredCarInfo}
                        </div>
                    </>
                )}
                {hiredTrailer && (
                    <>
                        <div className="show-bid__main-info--title">Наёмный прицеп</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-trailer-number">
                            {hiredTrailerInfo}
                        </div>
                    </>
                )}
                {hiredDriver && (
                    <>
                        <div className="show-bid__main-info--title">Наёмный водитель</div>
                        <div className="show-bid__main-info--value" data-test-id="hired-driver-name">
                            {[hiredDriver.lastName, hiredDriver.firstName, hiredDriver.patronymic]
                                .filter(Boolean)
                                .join(" ")}
                            {hiredDriver.phoneNumber && (
                                <>
                                    <br />
                                    {hiredDriver.phoneNumber}
                                </>
                            )}
                        </div>
                    </>
                )}
            </>
        );
    };

    renderDocuments = () => {
        const { documents } = this.state.data;
        if (!documents || documents.length === 0) {
            return null;
        }
        return <BidDocuments documents={documents || []} />;
    };

    renderExtendedProperties = (config, values) => {
        return config.map((prop) => {
            if (!values) {
                return null;
            }
            const valueObj = values.find((item) => item.propertyName === prop.propertyName);
            return (
                <Fragment key={prop.id}>
                    <div className="show-bid__main-info--title" style={prop.order ? { order: prop.order } : {}}>
                        {prop.displayName}
                    </div>
                    <div
                        className="show-bid__main-info--value"
                        data-test-id="extended-property"
                        style={prop.order ? { order: prop.order } : {}}
                    >
                        {valueObj ? formatExtendedProp(valueObj.value, prop.typeCode) : ""}
                    </div>
                </Fragment>
            );
        });
    };

    renderDocumentAssigmentStatus = () => {
        const { availableFeatureModules } = this.props.profile;
        if (!availableFeatureModules.includes(featureModuleTypesEnum.DocumentAssignment)) {
            return null;
        }
        const { createDocumentAssignment } = this.state.data;

        return (
            <>
                <div className="show-bid__main-info--title">Создать водителю задачу по сдаче документов</div>
                <div className="show-bid__main-info--value" data-test-id="create-document-assignment">
                    {createDocumentAssignment ? "Да" : "Нет"}
                </div>
            </>
        );
    };

    renderParcelInfo = () => {
        const { organization } = this.props;
        const { data } = this.state;

        if (
            data.hiredCarCounterpartyId &&
            (organization.enabledParcelProviders?.length > 0 || data.parcels?.length > 0)
        ) {
            return (
                <BidParcels
                    bid={data}
                    modal={this.props.modal}
                    getItem={this.getItem}
                    relationType={parcelRelationTypesEnum.DistributionBid}
                    providers={organization.enabledParcelProviders}
                />
            );
        } else {
            return null;
        }
    };

    renderShippingOrder = () => {
        if (!this.bidPolicy.hasEbillsAccess()) {
            return null;
        }

        const { shippingOrder } = this.state.data;
        if (!shippingOrder) {
            return null;
        }

        return <ShippingOrderSection shippingOrder={shippingOrder} defaultCollapsed={true} roles={this.props.roles} />;
    };

    renderResponsibleInfo = () => {
        const { responsible } = this.state.data;
        const { shortName } = responsible || {};
        if (!responsible) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Ответственный</div>
                <div className="show-bid__main-info--value" data-test-id="responsible">
                    {shortName && <span className="pr-1">{shortName}</span>}
                </div>
            </>
        );
    };

    renderClientBidNumber = () => {
        const { clientBidNumber } = this.state.data;
        if (!clientBidNumber) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Номер заявки клиента</div>
                <div className="show-bid__main-info--value" data-test-id="clientBidNumber">
                    {clientBidNumber}
                </div>
            </>
        );
    };

    renderClientBidDate = () => {
        const { clientBidDate } = this.state.data;
        if (!clientBidDate) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Дата заявки клиента</div>
                <div className="show-bid__main-info--value" data-test-id="clientBidDate">
                    {dateToView(clientBidDate)}
                </div>
            </>
        );
    };

    renderTemperatureRegime = () => {
        if (!this.temperatureRegimeEnabled) {
            return null;
        }
        const { temperatureRegime } = this.state.data;
        if (
            !(
                temperatureRegime &&
                temperatureRegime.temperatureMinimum != null &&
                temperatureRegime.temperatureMaximum != null
            )
        ) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Температурный режим</div>
                <div className="show-bid__main-info--value" data-test-id="temperature-regime">
                    {temperatureRegime &&
                        temperatureRegime.temperatureMinimum != null &&
                        temperatureRegime.temperatureMaximum != null && (
                            <>
                                Критический диапазон: с {temperatureRegime.temperatureMinimum}℃ до{" "}
                                {temperatureRegime.temperatureMaximum}℃
                                <br />
                            </>
                        )}
                </div>
            </>
        );
    };

    renderBody = () => {
        if (!this.state.data) {
            return null;
        }
        const { extendedPropertiesConfig } = this.state;
        const { extendedProperties } = this.state.data;
        return (
            <div className="show-bid__sections">
                {this.mainInfoHeader()}
                <div className="show-bid__main-info">
                    {this.renderCancellationComment()}
                    {this.renderHiredCar()}
                    {this.renderBid()}
                    {this.renderPrice()}
                    {this.renderDistance()}
                    {this.renderOutput()}
                    {this.renderCounterparty()}
                    {this.renderLegalPerson()}
                    {this.renderComment()}
                    {this.renderContact()}
                    {this.renderContractNumber()}
                    {this.renderContract()}
                    {this.renderTrailerType()}
                    {this.renderDocumentAssigmentStatus()}
                    {this.renderTemperatureRegime()}
                    {this.renderClientBidNumber()}
                    {this.renderClientBidDate()}
                    <BidSyncStatusInfo organizationTimezone={this.props.organizationTimezone} bid={this.state.data} />
                    {this.renderCreatedAtInfo()}
                    {this.renderResponsibleInfo()}
                    {this.renderSource()}
                    {this.renderTypeOptions()}
                    {this.renderExtendedProperties(extendedPropertiesConfig.bid, extendedProperties)}
                </div>
                {this.renderShippingOrder()}
                {this.renderParcelInfo()}
                <div className="show-bid__section-header">Маршрут</div>
                {this.renderTimeline()}
                <div className="show-bid__section-header">Груз</div>
                <div className="show-bid__cargo-container">{this.renderCargoPoints()}</div>
                {this.renderDocuments()}
                {this.renderTollRoads()}
            </div>
        );
    };

    render() {
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const { roles } = this.props;
        return (
            <div className="page-book__list show-bid">
                {this.renderHead()}
                {!policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() && this.renderActions()}
                <div className="show-bid__body-wrapper">
                    <div className="h-100 overflow-auto">{this.renderBody()}</div>
                </div>
            </div>
        );
    }
}

export default connect(DistributionBidShow);
